import { inject, Injectable } from '@angular/core';
import { HttpService } from '../../core/services';
import type {
  AnswerChannelMeetingPayload,
  ChannelMeetingStatusPayload,
  DeclineChannelMeetingPayload,
  EndChannelMeetingPayload,
  JoinChannelMeetingPayload,
  StartChannelMeetingPayload,
} from './meeting.models';

@Injectable({
  providedIn: 'root'
})
export class MeetingApi {
  private readonly httpService = inject(HttpService);

  startChannelMeeting(payload: StartChannelMeetingPayload) {
    return this.httpService.post('meeting/channel/start', payload, true);
  }

  answerChannelMeeting(payload: AnswerChannelMeetingPayload) {
    return this.httpService.post('meeting/channel/answer', payload, true);
  }

  joinChannelMeeting(payload: JoinChannelMeetingPayload) {
    return this.httpService.post('meeting/channel/join', payload, true);
  }

  getChannelMeetingStatus(payload: ChannelMeetingStatusPayload) {
    const query = new URLSearchParams({ channel_id: payload.channel_id }).toString();
    return this.httpService.get(`meeting/channel/status?${query}`, true);
  }

  declineChannelMeeting(payload: DeclineChannelMeetingPayload) {
    return this.httpService.post('meeting/channel/decline', payload, true);
  }

  endChannelMeeting(payload: EndChannelMeetingPayload) {
    return this.httpService.post('meeting/channel/end', payload, true);
  }
}
